import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import axios from "axios";
import VueAxios from "vue-axios";
import authInterceptors from "./services/auth-interceptor";
import Antd from "ant-design-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap";
import Emitter from "tiny-emitter";
import "@/assets/styles/style.scss";
import SessionTimeoutPlugin from "@/common/sessionTimeout";
import azureService from "@/services/azure-service";
 
authInterceptors(store);
 
async function processMsalRedirect() {
  try {
    const msal = await azureService.getMsalInstance();
    const response = await msal.handleRedirectPromise();
 
    if (response) {
      const { accessToken, idToken, account } = response;
      const userName = account?.name || account?.username || "User";
 
      localStorage.setItem("access_token", accessToken);
      if (idToken) localStorage.setItem("id_token", idToken);
      localStorage.setItem("user_name", userName);
 
      store.commit("auth/LOGIN_SUCCESS", {
        token: accessToken,
        user: { name: userName },
      });
 
      // Forward to wherever the user was originally trying to go
      // or default to /home if this was a fresh login.
      const storedRedirect = localStorage.getItem("postLoginRedirect");
      if (storedRedirect) {
        localStorage.removeItem("postLoginRedirect");
        router.isReady().then(() => router.replace(storedRedirect));
      } else {
        router.isReady().then(() => router.replace("/home"));
      }
    } else {
      // Restore Vuex auth state from localStorage if the store was cleared
      const accounts = msal.getAllAccounts();
      const cachedToken = localStorage.getItem("access_token");
      if (accounts.length > 0 && cachedToken && !store.state.auth?.loggedIn) {
        const userName = accounts[0]?.name || localStorage.getItem("user_name") || "User";
        store.commit("auth/LOGIN_SUCCESS", {
          token: cachedToken,
          user: { name: userName },
        });
      }
    }
  } catch (error) {
    console.error("MSAL redirect handling failed:", error);
    localStorage.setItem("login_error", error?.message || "Login failed");
    router.isReady().then(() => router.replace("/login"));
  }
}
 
processMsalRedirect().then(() => {
  const app = createApp(App)
    .use(store)
    .use(router)
    .use(Antd)
    .use(Emitter)
    .use(VueAxios, axios)
    .use(SessionTimeoutPlugin, {
      router,
      store,
      axiosInstance: axios,
      loginRoute: "/login",
      publicPaths: ["/login"],
      protectRoutes: true,
    });
 
  app.config.globalProperties.$msalInstance = {};
  app.config.globalProperties.$emitter = new Emitter();
  app.provide("$msalInstance", app.config.globalProperties.$msalInstance);
  app.provide("$emitter", app.config.globalProperties.$emitter);
  app.provide("axios", app.config.globalProperties.axios);
 
  app.mount("#app");
});